import React, { Component } from "react";
import TextareaAutosize from 'react-autosize-textarea';
import uploadFile from "./upload-file.png";

class AddMetaDesktop extends Component {
  constructor() {
    super();
    this.state = {
      file: "",
      text: "",
      title: "",
      description: "",
      keyword: ""
    };
    this.showFile = this.showFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  showFile = function(event) {
    const previewFile = document.getElementById("fileName");
    const file = event.target.files[0];
    const filename = event.target.files[0].name;
    const reader = new FileReader();
    const scope = this;
    reader.onload = function(e) {
      const source = reader.result;
      scope.setState({ text: source, file: filename });
      previewFile.innerHTML = filename;

      console.log("EPS file is ready >>>");
      console.log("File name: " + filename);
    };
    reader.readAsText(file);
  };

  handleChange(event) {
    return function(e) {
      const state = {};
      state[event] = e.target.value;
      this.setState(state);
    }.bind(this);
  }

  handleSubmit(event) {
    const data = {
      file: this.state.file,
      text: this.state.text,
      title: this.state.title,
      description: this.state.description,
      keyword: this.state.keyword
    };

    console.log(
      "Title: " +
        data.title +
        "\nDescription: " +
        data.description +
        "\nKeyword: " +
        data.keyword
    );

    event.preventDefault();

    console.log(
      data.keyword.split(/\s*(?:,|$)\s*\s+/g).length,
      new Map(Object.entries(data.keyword.split(/\s*(?:,|$)\s*\s+/g)))
    );

    const lines = data.text.split(/\n/);
    console.log(lines.length);

    const firstStr = data.text
      .split(/\n/, 14)
      .map(function(line) {
        return line + "\n";
      })
      .join("");

    const keywordList = data.keyword
      .split(/\s*(?:,|$)\s*\s+/g)
      .map(function(key) {
        return "\n\t\t\t<rdf:li>" + key + "</rdf:li>";
      })
      .join("");

    const lasttStr = data.text
      .split(/\n/)
      .slice(15)
      .map(function(line) {
        return line + "\n";
      })
      .join("");

    const beginText = '\n/currentdistillerparams where' +
    '\n{pop currentdistillerparams /CoreDistVersion get 5000 lt} {true} ifelse' +
    '\n{userdict /EPSHandler1_pdfmark /cleartomark load put' +
    '\nuserdict /EPSHandler1_ReadMetadata_pdfmark {flushfile cleartomark} bind put}' +
    '\n{ userdict /EPSHandler1_pdfmark /pdfmark load put' +
    '\nuserdict /EPSHandler1_ReadMetadata_pdfmark {/PUT pdfmark} bind put } ifelse' +
    '\n[/NamespacePush EPSHandler1_pdfmark' +
    '\n[/_objdef {eps_metadata_stream} /type /stream /OBJ EPSHandler1_pdfmark' +
    '\n[{eps_metadata_stream} 2 dict begin' +
    '\n/Type /Metadata def /Subtype /XML def currentdict end /PUT EPSHandler1_pdfmark' +
    '\n[{eps_metadata_stream}' +
    '\ncurrentfile 0 (% &&end EPS XMP packet marker&&)' +
    '\n/SubFileDecode filter EPSHandler1_ReadMetadata_pdfmark' +
    '\n<?xpacket begin="﻿" id="W5M0MpCehiHzreSzNTczkc9d"?>' +
    '\n<x:xmpmeta xmlns:x="adobe:ns:meta/" x:xmptk="XMP Core 5.5.0">' +
     '\n<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">' +
      '\n<rdf:Description rdf:about=""' +
        '\nxmlns:exif="http://ns.adobe.com/exif/1.0/"' +
        '\nxmlns:tiff="http://ns.adobe.com/tiff/1.0/"' +
        '\nxmlns:photoshop="http://ns.adobe.com/photoshop/1.0/"' +
        '\nxmlns:xmp="http://ns.adobe.com/xap/1.0/"' +
        '\nxmlns:xmpMM="http://ns.adobe.com/xap/1.0/mm/"' +
        '\nxmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#"' +
       '\ntiff:ResolutionUnit="2"' +
       '\ntiff:XResolution="72.0"' +
       '\ntiff:YResolution="72.0"' +
       '\nphotoshop:ColorMode="3"' +
       '\nphotoshop:ICCProfile="sRGB IEC61966-2.1"';

    const endText = '\n</rdf:Description>' +
      '\n</rdf:RDF>' +
     '\n</x:xmpmeta>' +
     '\n\n\n<?xpacket end="w"?>' +
     '\n% &&end EPS XMP packet marker&&' +
     '\n[/Document' +
     '\n1 dict begin /Metadata {eps_metadata_stream} def' +
     '\ncurrentdict end /BDC EPSHandler1_pdfmark' +
     '\n[/NamespacePop EPSHandler1_pdfmark';

    const element = document.createElement("a");
    const metadata = new Blob(
      [
        firstStr +
        beginText +
          "\n\t<dc:format>application/postscript</dc:format>" +
          "\n\t<dc:title>" +
          "\n\t\t<rdf:Alt>" +
          '\n\t\t\t<rdf:li xml:lang="x-default">' +
          data.title +
          "</rdf:li>" +
          "\n\t\t</rdf:Alt>" +
          "\n\t</dc:title>" +
          "\n\t<dc:description>" +
          "\n\t\t<rdf:Alt>" +
          '\n\t\t\t<rdf:li xml:lang="x-default">' +
          data.description +
          "</rdf:li>" +
          "\n\t\t</rdf:Alt>" +
          "\n\t</dc:description>" +
          "\n\t<dc:subject>" +
          "\n\t\t<rdf:Bag>" +
          keywordList +
          "\n\t\t</rdf:Bag>" +
          "\n\t</dc:subject>\n\n" +
          endText +
          "\n\ngsave\n" +
          lasttStr
      ],
      {
        type: "text/eps"
      }
    );
    element.href = URL.createObjectURL(metadata);
    element.download = "Magic-EPS-" + data.file;
    document.body.appendChild(element);
    element.click();
  }

  render() {
    return (
      <div className="mainContent">
        <form onSubmit={this.handleSubmit} autoComplete="off">
          <label className="uploadFile">
            <img className="uploadImg" src={uploadFile} alt="Upload File" />
            <div id="fileName">Choose an EPS File</div>
            <input
              required
              type="file"
              accept=".eps"
              onChange={this.showFile}
            />
            <div
              name="text"
              id="metaFile"
              value={this.state.text}
              onChange={this.handleChange("text")}
            />
          </label>
          <label>
            <TextareaAutosize
              required
              maxLength={200}
              name="title"
              id="metaTitle"
              placeholder={"Title"}
              value={this.state.title}
              onChange={this.handleChange("title")}
            />
            <div id="charLenght">{this.state.title.length}/200</div>
          </label>
          <label>
            <TextareaAutosize
              required
              maxLength={200}
              name="description"
              id="metaDescription"
              placeholder={"Description"}
              value={this.state.description}
              onChange={this.handleChange("description")}
            />
            <div id="charLenght">{this.state.description.length}/200</div>
          </label>
          <label>
            <TextareaAutosize
              required
              name="keyword"
              id="metaKeyword"
              placeholder={"Enter your keywords here..."}
              value={this.state.keyword}
              onChange={this.handleChange("keyword")}
            />
            <div id="charLenght">{this.state.keyword ? this.state.keyword.split(/\s*(?:,|$)\s*\s+/g).length : 0}/50</div>
          </label>
          <input type="submit" id="addMeta" value="Download EPS File" />
        </form>
      </div>
    );
  }
}

export default AddMetaDesktop;
